import { Button } from '@mui/material';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import './EmailEditor.scss';

interface EmailEditorProp {
    onClick?: () => void,
    className?: string,
    disable?: boolean,
}

const EmailEditorButton: React.FunctionComponent<EmailEditorProp> = (props) => {
    const dispatch = useDispatch();

    return (
        <>
            <span
                className={'email-editor-button ' + (props.disable ? "email-disable" : "")}
                onClick={() => {
                    if (props.onClick && !props.disable) {
                        props.onClick();
                    }
                }}
            ><i className="fa fa-envelope-o" aria-hidden="true"></i></span>
        </>
    )
};

export default EmailEditorButton;